<template>

<v-dialog v-model="dialog" width="800px">
  <v-card v-if="!loading">
    <p class=".title ma-2">{{txts.huis_code }} - {{txts.taal_code}}
      <span v-if="txts.updated_by!==''" class="ml-5">Last updated by 
        <span>
          <strong>{{ txts.updated_name }}</strong>
        </span> at {{ formatDate(txts.updated_isodt) }} ({{ txts.updated_type.toUpperCase() }})
      </span>
    </p>


    <v-row no-gutters>
      <v-col class="mx-2">
        <v-textarea v-model="txts.text" :value=txts.text rows="10" :label=txts.label counter></v-textarea>
      </v-col>
    </v-row>

    <table v-if="txts.trsl">
      <tr><td>Translate into:</td>
          
        <td v-for="(trslRecord,i) in txts.trsl" :key="i" ><a @click="trsl(txts.taal_code,trslRecord.taal_code)"><country-flag class="mx-1" v-bind:country=trslRecord.taal_country_flag /></a></td>
      </tr>     
    </table>    
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveTxts">Save</v-btn>
      <v-btn color="primary"  small @click="closeDialog">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

export default {
  data() { 
    return {
      dialog: false,
      loading: true,
      txts: {}
    }
  },
  methods: {
    formatDate(dt){
      if (!dt) return '';
      const date = new Date(dt);
      const pad = (num) => String(num).padStart(2, '0');
      return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    open(huis_encrid,veld_naam,taal_code) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.loading = true;
      this.$axios
        .post("ares/json/ares/huis/txts/getTxts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getTxts"
          },
          getTxts: {
            huis_encrid: huis_encrid,
            txts_veld_naam: veld_naam,
            taal_code: taal_code
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false;
          } else {
            this.txts = res.data.getTxts;
            this.loading = false;
          }
        })
    },
    saveTxts() { 
      this.$axios
        .post("ares/json/ares/huis/txts/saveTxts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveTxts"
          },
          saveTxts: {
            huis_encrid: this.txts.huis_encrid,
            taal_code: this.txts.taal_code,
            txts_veld_naam: this.txts.txts_veld_naam,
            text: this.txts.text
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveTxts.text,
              color: res.data.saveTxts.color
            });             
            this.closeDialog();
          }
        })
    },
    closeDialog() {
      this.$emit('updateTextData');
      this.dialog = false;
    },
    trsl(from,to) {
      this.$axios
        .post("ares/json/ares/huis/txts/trslTxts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "trslTxts"
          },
          trslTxts: {
            huis_encrid: this.txts.huis_encrid,
            taal_code_from: from,
            taal_code_to: to, 
            txts_veld_naam: this.txts.txts_veld_naam
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {                     
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.trslTxts.text,
              color: res.data.trslTxts.color
            }); 
            if (res.data.trslTxts.color == "success") {
              this.closeDialog();
            }            
          }
        })
    }
  }
}
</script>

